import { jsx as R, jsxs as ne, Fragment as He } from "react/jsx-runtime";
import * as l from "react";
import { useMemo as Ie, useEffect as Ge } from "react";
import { C as Ve, M as Xe, G as Qe, a as Je, A as Ue, b as Ke, c as Ze } from "./chatLayout.styles.js";
import { theme as et } from "../theme/index.js";
import { g as Oe, m as Pe, o as Se, u as tt, z as nt, C as le, n as B, E as rt } from "./CSSMotionList.js";
import { R as at } from "./index5.js";
import { u as ot, r as st } from "./useBreakpoint.js";
import { d as Ce } from "./warning.js";
import "./index.js";
import { a as Me, P as it, t as ct } from "./ContextIsolator.js";
import { a as ut, u as lt } from "./useSize.js";
import { c as ke } from "./reactNode.js";
import { K as dt } from "./KeyCode.js";
import { i as mt, g as ft } from "./zoom.js";
import { g as ht, a as gt, P as yt, T as pt } from "./index6.js";
import { a as bt } from "./roundedArrow.js";
import "./useId.js";
const ce = /* @__PURE__ */ l.createContext({}), vt = (e) => {
  const {
    antCls: t,
    componentCls: n,
    iconCls: r,
    avatarBg: a,
    avatarColor: o,
    containerSize: i,
    containerSizeLG: s,
    containerSizeSM: c,
    textFontSize: m,
    textFontSizeLG: u,
    textFontSizeSM: h,
    borderRadius: y,
    borderRadiusLG: p,
    borderRadiusSM: g,
    lineWidth: d,
    lineType: v
  } = e, k = (f, P, T) => ({
    width: f,
    height: f,
    borderRadius: "50%",
    [`&${n}-square`]: {
      borderRadius: T
    },
    [`&${n}-icon`]: {
      fontSize: P,
      [`> ${r}`]: {
        margin: 0
      }
    }
  });
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, Se(e)), {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      color: o,
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "middle",
      background: a,
      border: `${tt(d)} ${v} transparent`,
      "&-image": {
        background: "transparent"
      },
      [`${t}-image-img`]: {
        display: "block"
      }
    }), k(i, m, y)), {
      "&-lg": Object.assign({}, k(s, u, p)),
      "&-sm": Object.assign({}, k(c, h, g)),
      "> img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    })
  };
}, wt = (e) => {
  const {
    componentCls: t,
    groupBorderColor: n,
    groupOverlapping: r,
    groupSpace: a
  } = e;
  return {
    [`${t}-group`]: {
      display: "inline-flex",
      [t]: {
        borderColor: n
      },
      "> *:not(:first-child)": {
        marginInlineStart: r
      }
    },
    [`${t}-group-popover`]: {
      [`${t} + ${t}`]: {
        marginInlineStart: a
      }
    }
  };
}, xt = (e) => {
  const {
    controlHeight: t,
    controlHeightLG: n,
    controlHeightSM: r,
    fontSize: a,
    fontSizeLG: o,
    fontSizeXL: i,
    fontSizeHeading3: s,
    marginXS: c,
    marginXXS: m,
    colorBorderBg: u
  } = e;
  return {
    containerSize: t,
    containerSizeLG: n,
    containerSizeSM: r,
    textFontSize: Math.round((o + i) / 2),
    textFontSizeLG: s,
    textFontSizeSM: a,
    groupSpace: m,
    groupOverlapping: -c,
    groupBorderColor: u
  };
}, Ee = Oe("Avatar", (e) => {
  const {
    colorTextLightSolid: t,
    colorTextPlaceholder: n
  } = e, r = Pe(e, {
    avatarBg: n,
    avatarColor: t
  });
  return [vt(r), wt(r)];
}, xt);
var Ot = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const de = /* @__PURE__ */ l.forwardRef((e, t) => {
  const {
    prefixCls: n,
    shape: r,
    size: a,
    src: o,
    srcSet: i,
    icon: s,
    className: c,
    rootClassName: m,
    style: u,
    alt: h,
    draggable: y,
    children: p,
    crossOrigin: g,
    gap: d = 4,
    onError: v
  } = e, k = Ot(e, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "style", "alt", "draggable", "children", "crossOrigin", "gap", "onError"]), [f, P] = l.useState(1), [T, A] = l.useState(!1), [Y, z] = l.useState(!0), L = l.useRef(null), j = l.useRef(null), F = nt(t, L), {
    getPrefixCls: $,
    avatar: E
  } = l.useContext(le), S = l.useContext(ce), W = () => {
    if (!j.current || !L.current)
      return;
    const x = j.current.offsetWidth, O = L.current.offsetWidth;
    x !== 0 && O !== 0 && d * 2 < O && P(O - d * 2 < x ? (O - d * 2) / x : 1);
  };
  l.useEffect(() => {
    A(!0);
  }, []), l.useEffect(() => {
    z(!0), P(1);
  }, [o]), l.useEffect(W, [d]);
  const q = () => {
    (v == null ? void 0 : v()) !== !1 && z(!1);
  }, w = ut((x) => {
    var O, U;
    return (U = (O = a ?? (S == null ? void 0 : S.size)) !== null && O !== void 0 ? O : x) !== null && U !== void 0 ? U : "default";
  }), Q = Object.keys(typeof w == "object" ? w || {} : {}).some((x) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(x)), I = ot(Q), te = l.useMemo(() => {
    if (typeof w != "object")
      return {};
    const x = st.find((U) => I[U]), O = w[x];
    return O ? {
      width: O,
      height: O,
      fontSize: O && (s || p) ? O / 2 : 18
    } : {};
  }, [I, w]);
  if (process.env.NODE_ENV !== "production") {
    const x = Ce("Avatar");
    process.env.NODE_ENV !== "production" && x(!(typeof s == "string" && s.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${s}\` at https://ant.design/components/icon`);
  }
  const C = $("avatar", n), M = Me(C), [G, J, Re] = Ee(C, M), Be = B({
    [`${C}-lg`]: w === "large",
    [`${C}-sm`]: w === "small"
  }), fe = /* @__PURE__ */ l.isValidElement(o), Ae = r || (S == null ? void 0 : S.shape) || "circle", Le = B(C, Be, E == null ? void 0 : E.className, `${C}-${Ae}`, {
    [`${C}-image`]: fe || o && Y,
    [`${C}-icon`]: !!s
  }, Re, M, c, m, J), qe = typeof w == "number" ? {
    width: w,
    height: w,
    fontSize: s ? w / 2 : 18
  } : {};
  let V;
  if (typeof o == "string" && Y)
    V = /* @__PURE__ */ l.createElement("img", {
      src: o,
      draggable: y,
      srcSet: i,
      onError: q,
      alt: h,
      crossOrigin: g
    });
  else if (fe)
    V = o;
  else if (s)
    V = s;
  else if (T || f !== 1) {
    const x = `scale(${f})`, O = {
      msTransform: x,
      WebkitTransform: x,
      transform: x
    };
    V = /* @__PURE__ */ l.createElement(at, {
      onResize: W
    }, /* @__PURE__ */ l.createElement("span", {
      className: `${C}-string`,
      ref: j,
      style: Object.assign({}, O)
    }, p));
  } else
    V = /* @__PURE__ */ l.createElement("span", {
      className: `${C}-string`,
      style: {
        opacity: 0
      },
      ref: j
    }, p);
  return G(/* @__PURE__ */ l.createElement("span", Object.assign({}, k, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, qe), te), E == null ? void 0 : E.style), u),
    className: Le,
    ref: F
  }), V));
});
process.env.NODE_ENV !== "production" && (de.displayName = "Avatar");
const re = (e) => e ? typeof e == "function" ? e() : e : null, Pt = (e) => {
  const {
    componentCls: t,
    popoverColor: n,
    titleMinWidth: r,
    fontWeightStrong: a,
    innerPadding: o,
    boxShadowSecondary: i,
    colorTextHeading: s,
    borderRadiusLG: c,
    zIndexPopup: m,
    titleMarginBottom: u,
    colorBgElevated: h,
    popoverBg: y,
    titleBorderBottom: p,
    innerContentPadding: g,
    titlePadding: d
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Se(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: m,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "--antd-arrow-background-color": h,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: y,
          backgroundClip: "padding-box",
          borderRadius: c,
          boxShadow: i,
          padding: o
        },
        [`${t}-title`]: {
          minWidth: r,
          marginBottom: u,
          color: s,
          fontWeight: a,
          borderBottom: p,
          padding: d
        },
        [`${t}-inner-content`]: {
          color: n,
          padding: g
        }
      })
    },
    // Arrow Style
    ht(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, St = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: it.map((n) => {
      const r = e[`${n}6`];
      return {
        [`&${t}-${n}`]: {
          "--antd-arrow-background-color": r,
          [`${t}-inner`]: {
            backgroundColor: r
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, Ct = (e) => {
  const {
    lineWidth: t,
    controlHeight: n,
    fontHeight: r,
    padding: a,
    wireframe: o,
    zIndexPopupBase: i,
    borderRadiusLG: s,
    marginXS: c,
    lineType: m,
    colorSplit: u,
    paddingSM: h
  } = e, y = n - r, p = y / 2, g = y / 2 - t, d = a;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: i + 30
  }, bt(e)), gt({
    contentRadius: s,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: o ? 0 : 12,
    titleMarginBottom: o ? 0 : c,
    titlePadding: o ? `${p}px ${d}px ${g}px` : 0,
    titleBorderBottom: o ? `${t}px ${m} ${u}` : "none",
    innerContentPadding: o ? `${h}px ${d}px` : 0
  });
}, Ne = Oe("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: n
  } = e, r = Pe(e, {
    popoverBg: t,
    popoverColor: n
  });
  return [Pt(r), St(r), mt(r, "zoom-big")];
}, Ct, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var Mt = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const De = ({
  title: e,
  content: t,
  prefixCls: n
}) => !e && !t ? null : /* @__PURE__ */ l.createElement(l.Fragment, null, e && /* @__PURE__ */ l.createElement("div", {
  className: `${n}-title`
}, e), t && /* @__PURE__ */ l.createElement("div", {
  className: `${n}-inner-content`
}, t)), kt = (e) => {
  const {
    hashId: t,
    prefixCls: n,
    className: r,
    style: a,
    placement: o = "top",
    title: i,
    content: s,
    children: c
  } = e, m = re(i), u = re(s), h = B(t, n, `${n}-pure`, `${n}-placement-${o}`, r);
  return /* @__PURE__ */ l.createElement("div", {
    className: h,
    style: a
  }, /* @__PURE__ */ l.createElement("div", {
    className: `${n}-arrow`
  }), /* @__PURE__ */ l.createElement(yt, Object.assign({}, e, {
    className: t,
    prefixCls: n
  }), c || /* @__PURE__ */ l.createElement(De, {
    prefixCls: n,
    title: m,
    content: u
  })));
}, Et = (e) => {
  const {
    prefixCls: t,
    className: n
  } = e, r = Mt(e, ["prefixCls", "className"]), {
    getPrefixCls: a
  } = l.useContext(le), o = a("popover", t), [i, s, c] = Ne(o);
  return i(/* @__PURE__ */ l.createElement(kt, Object.assign({}, r, {
    prefixCls: o,
    hashId: s,
    className: B(n, c)
  })));
};
var Nt = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Dt = /* @__PURE__ */ l.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: a,
    title: o,
    content: i,
    overlayClassName: s,
    placement: c = "top",
    trigger: m = "hover",
    children: u,
    mouseEnterDelay: h = 0.1,
    mouseLeaveDelay: y = 0.1,
    onOpenChange: p,
    overlayStyle: g = {},
    styles: d,
    classNames: v
  } = e, k = Nt(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]), {
    getPrefixCls: f,
    className: P,
    style: T,
    classNames: A,
    styles: Y
  } = rt("popover"), z = f("popover", a), [L, j, F] = Ne(z), $ = f(), E = B(s, j, F, P, A.root, v == null ? void 0 : v.root), S = B(A.body, v == null ? void 0 : v.body), [W, q] = lt(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), w = (M, G) => {
    q(M, !0), p == null || p(M, G);
  }, Q = (M) => {
    M.keyCode === dt.ESC && w(!1, M);
  }, I = (M) => {
    w(M);
  }, te = re(o), C = re(i);
  return L(/* @__PURE__ */ l.createElement(pt, Object.assign({
    placement: c,
    trigger: m,
    mouseEnterDelay: h,
    mouseLeaveDelay: y
  }, k, {
    prefixCls: z,
    classNames: {
      root: E,
      body: S
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, Y.root), T), g), d == null ? void 0 : d.root),
      body: Object.assign(Object.assign({}, Y.body), d == null ? void 0 : d.body)
    },
    ref: t,
    open: W,
    onOpenChange: I,
    overlay: te || C ? /* @__PURE__ */ l.createElement(De, {
      prefixCls: z,
      title: te,
      content: C
    }) : null,
    transitionName: ft($, "zoom-big", k.transitionName),
    "data-popover-inject": !0
  }), ke(u, {
    onKeyDown: (M) => {
      var G, J;
      /* @__PURE__ */ l.isValidElement(u) && ((J = u == null ? void 0 : (G = u.props).onKeyDown) === null || J === void 0 || J.call(G, M)), Q(M);
    }
  })));
}), me = Dt;
me._InternalPanelDoNotUseOrYouWillBeFired = Et;
process.env.NODE_ENV !== "production" && (me.displayName = "Popover");
const he = (e) => {
  const {
    size: t,
    shape: n
  } = l.useContext(ce), r = l.useMemo(() => ({
    size: e.size || t,
    shape: e.shape || n
  }), [e.size, e.shape, t, n]);
  return /* @__PURE__ */ l.createElement(ce.Provider, {
    value: r
  }, e.children);
}, Wt = (e) => {
  var t, n, r, a;
  const {
    getPrefixCls: o,
    direction: i
  } = l.useContext(le), {
    prefixCls: s,
    className: c,
    rootClassName: m,
    style: u,
    maxCount: h,
    maxStyle: y,
    size: p,
    shape: g,
    maxPopoverPlacement: d,
    maxPopoverTrigger: v,
    children: k,
    max: f
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const S = Ce("Avatar.Group");
    [["maxCount", "max={{ count: number }}"], ["maxStyle", "max={{ style: CSSProperties }}"], ["maxPopoverPlacement", "max={{ popover: PopoverProps }}"], ["maxPopoverTrigger", "max={{ popover: PopoverProps }}"]].forEach(([W, q]) => {
      S.deprecated(!(W in e), W, q);
    });
  }
  const P = o("avatar", s), T = `${P}-group`, A = Me(P), [Y, z, L] = Ee(P, A), j = B(T, {
    [`${T}-rtl`]: i === "rtl"
  }, L, A, c, m, z), F = ct(k).map((S, W) => ke(S, {
    // eslint-disable-next-line react/no-array-index-key
    key: `avatar-key-${W}`
  })), $ = (f == null ? void 0 : f.count) || h, E = F.length;
  if ($ && $ < E) {
    const S = F.slice(0, $), W = F.slice($, E), q = (f == null ? void 0 : f.style) || y, w = ((t = f == null ? void 0 : f.popover) === null || t === void 0 ? void 0 : t.trigger) || v || "hover", Q = ((n = f == null ? void 0 : f.popover) === null || n === void 0 ? void 0 : n.placement) || d || "top", I = Object.assign(Object.assign({
      content: W
    }, f == null ? void 0 : f.popover), {
      classNames: {
        root: B(`${T}-popover`, (a = (r = f == null ? void 0 : f.popover) === null || r === void 0 ? void 0 : r.classNames) === null || a === void 0 ? void 0 : a.root)
      },
      placement: Q,
      trigger: w
    });
    return S.push(/* @__PURE__ */ l.createElement(me, Object.assign({
      key: "avatar-popover-key",
      destroyOnHidden: !0
    }, I), /* @__PURE__ */ l.createElement(de, {
      style: q
    }, `+${E - $}`))), Y(/* @__PURE__ */ l.createElement(he, {
      shape: g,
      size: p
    }, /* @__PURE__ */ l.createElement("div", {
      className: j,
      style: u
    }, S)));
  }
  return Y(/* @__PURE__ */ l.createElement(he, {
    shape: g,
    size: p
  }, /* @__PURE__ */ l.createElement("div", {
    className: j,
    style: u
  }, F)));
}, We = de;
We.Group = Wt;
const Te = 6048e5, Tt = 864e5, ge = Symbol.for("constructDateFrom");
function N(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && ge in e ? e[ge](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function D(e, t) {
  return N(t || e, e);
}
function jt(e, t, n) {
  const r = D(e, n == null ? void 0 : n.in);
  return isNaN(t) ? N(e, NaN) : (r.setDate(r.getDate() + t), r);
}
let $t = {};
function se() {
  return $t;
}
function ee(e, t) {
  var s, c, m, u;
  const n = se(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((u = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = D(e, t == null ? void 0 : t.in), o = a.getDay(), i = (o < r ? 7 : 0) + o - r;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function ae(e, t) {
  return ee(e, { ...t, weekStartsOn: 1 });
}
function je(e, t) {
  const n = D(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = N(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const o = ae(a), i = N(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const s = ae(i);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function ye(e) {
  const t = D(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function $e(e, ...t) {
  const n = N.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function oe(e, t) {
  const n = D(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Yt(e, t, n) {
  const [r, a] = $e(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = oe(r), i = oe(a), s = +o - ye(o), c = +i - ye(i);
  return Math.round((s - c) / Tt);
}
function zt(e, t) {
  const n = je(e, t), r = N(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), ae(r);
}
function Ye(e) {
  return N(e, Date.now());
}
function ze(e, t, n) {
  const [r, a] = $e(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +oe(r) == +oe(a);
}
function Ft(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function _t(e) {
  return !(!Ft(e) && typeof e != "number" || isNaN(+D(e)));
}
function Rt(e, t) {
  const n = D(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Bt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, At = (e, t, n) => {
  let r;
  const a = Bt[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ie(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Lt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, qt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ht = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, It = {
  date: ie({
    formats: Lt,
    defaultWidth: "full"
  }),
  time: ie({
    formats: qt,
    defaultWidth: "full"
  }),
  dateTime: ie({
    formats: Ht,
    defaultWidth: "full"
  })
}, Gt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Vt = (e, t, n, r) => Gt[e];
function K(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      a = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[o];
  };
}
const Xt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Qt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Jt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ut = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Kt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Zt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, en = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, tn = {
  ordinalNumber: en,
  era: K({
    values: Xt,
    defaultWidth: "wide"
  }),
  quarter: K({
    values: Qt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: K({
    values: Jt,
    defaultWidth: "wide"
  }),
  day: K({
    values: Ut,
    defaultWidth: "wide"
  }),
  dayPeriod: K({
    values: Kt,
    defaultWidth: "wide",
    formattingValues: Zt,
    defaultFormattingWidth: "wide"
  })
};
function Z(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    const i = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? rn(s, (h) => h.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      nn(s, (h) => h.test(i))
    );
    let m;
    m = e.valueCallback ? e.valueCallback(c) : c, m = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(m)
    ) : m;
    const u = t.slice(i.length);
    return { value: m, rest: u };
  };
}
function nn(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function rn(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function an(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(a.length);
    return { value: i, rest: s };
  };
}
const on = /^(\d+)(th|st|nd|rd)?/i, sn = /\d+/i, cn = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, un = {
  any: [/^b/i, /^(a|c)/i]
}, ln = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, dn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mn = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, fn = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, hn = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gn = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, yn = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, pn = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, bn = {
  ordinalNumber: an({
    matchPattern: on,
    parsePattern: sn,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: cn,
    defaultMatchWidth: "wide",
    parsePatterns: un,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: ln,
    defaultMatchWidth: "wide",
    parsePatterns: dn,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: mn,
    defaultMatchWidth: "wide",
    parsePatterns: fn,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: hn,
    defaultMatchWidth: "wide",
    parsePatterns: gn,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: yn,
    defaultMatchWidth: "any",
    parsePatterns: pn,
    defaultParseWidth: "any"
  })
}, vn = {
  code: "en-US",
  formatDistance: At,
  formatLong: It,
  formatRelative: Vt,
  localize: tn,
  match: bn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function wn(e, t) {
  const n = D(e, t == null ? void 0 : t.in);
  return Yt(n, Rt(n)) + 1;
}
function xn(e, t) {
  const n = D(e, t == null ? void 0 : t.in), r = +ae(n) - +zt(n);
  return Math.round(r / Te) + 1;
}
function Fe(e, t) {
  var u, h, y, p;
  const n = D(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = se(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (y = a.locale) == null ? void 0 : y.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = N((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(r + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = ee(i, t), c = N((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(r, 0, o), c.setHours(0, 0, 0, 0);
  const m = ee(c, t);
  return +n >= +s ? r + 1 : +n >= +m ? r : r - 1;
}
function On(e, t) {
  var s, c, m, u;
  const n = se(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = Fe(e, t), o = N((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0), ee(o, t);
}
function Pn(e, t) {
  const n = D(e, t == null ? void 0 : t.in), r = +ee(n, t) - +On(n, t);
  return Math.round(r / Te) + 1;
}
function b(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const _ = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return b(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : b(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return b(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return b(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return b(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return b(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return b(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return b(a, t.length);
  }
}, X = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, pe = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return _.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = Fe(e, r), o = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const i = o % 100;
      return b(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : b(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = je(e);
    return b(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return b(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return b(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return b(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return _.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return b(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = Pn(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : b(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = xn(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : b(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : _.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = wn(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : b(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return b(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return b(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return b(a, t.length);
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = X.noon : r === 0 ? a = X.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = X.evening : r >= 12 ? a = X.afternoon : r >= 4 ? a = X.morning : a = X.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return _.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : _.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : b(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : b(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : _.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : _.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return _.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return ve(r);
      case "XXXX":
      case "XX":
        return H(r);
      case "XXXXX":
      case "XXX":
      default:
        return H(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return ve(r);
      case "xxxx":
      case "xx":
        return H(r);
      case "xxxxx":
      case "xxx":
      default:
        return H(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + be(r, ":");
      case "OOOO":
      default:
        return "GMT" + H(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + be(r, ":");
      case "zzzz":
      default:
        return "GMT" + H(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return b(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return b(+e, t.length);
  }
};
function be(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(a) : n + String(a) + t + b(o, 2);
}
function ve(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + b(Math.abs(e) / 60, 2) : H(e, t);
}
function H(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = b(Math.trunc(r / 60), 2), o = b(r % 60, 2);
  return n + a + t + o;
}
const we = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, _e = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Sn = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return we(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", we(r, t)).replace("{{time}}", _e(a, t));
}, Cn = {
  p: _e,
  P: Sn
}, Mn = /^D+$/, kn = /^Y+$/, En = ["D", "DD", "YY", "YYYY"];
function Nn(e) {
  return Mn.test(e);
}
function Dn(e) {
  return kn.test(e);
}
function Wn(e, t, n) {
  const r = Tn(e, t, n);
  if (console.warn(r), En.includes(e)) throw new RangeError(r);
}
function Tn(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const jn = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $n = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Yn = /^'([^]*?)'?$/, zn = /''/g, Fn = /[a-zA-Z]/;
function ue(e, t, n) {
  var u, h, y, p;
  const r = se(), a = r.locale ?? vn, o = r.firstWeekContainsDate ?? ((h = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = r.weekStartsOn ?? ((p = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = D(e, n == null ? void 0 : n.in);
  if (!_t(s))
    throw new RangeError("Invalid time value");
  let c = t.match($n).map((g) => {
    const d = g[0];
    if (d === "p" || d === "P") {
      const v = Cn[d];
      return v(g, a.formatLong);
    }
    return g;
  }).join("").match(jn).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const d = g[0];
    if (d === "'")
      return { isToken: !1, value: _n(g) };
    if (pe[d])
      return { isToken: !0, value: g };
    if (d.match(Fn))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: g };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const m = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return c.map((g) => {
    if (!g.isToken) return g.value;
    const d = g.value;
    (Dn(d) || Nn(d)) && Wn(d, t, String(e));
    const v = pe[d[0]];
    return v(s, d, a.localize, m);
  }).join("");
}
function _n(e) {
  const t = e.match(Yn);
  return t ? t[1].replace(zn, "'") : e;
}
function Rn(e, t) {
  return ze(
    N(e, e),
    Ye(e)
  );
}
function Bn(e, t, n) {
  return jt(e, -t, n);
}
function An(e, t) {
  return ze(
    N(e, e),
    Bn(Ye(e), 1)
  );
}
const Ln = ({
  content: e
}) => e, qn = (e) => {
  const t = e instanceof Date ? ue(e, "PP") : e;
  return /* @__PURE__ */ R("span", { className: "text-gray-500 px-2 py-1 rounded-md bg-gray-50", children: t });
}, Hn = ({
  role: e,
  avatarConfig: t
}) => {
  const { avatar: n, label: r } = e, a = {
    sm: "small",
    md: "default",
    lg: "large"
  }, { size: o } = t, i = {
    size: a[o],
    style: {
      fontWeight: et.fontWeight.semibold,
      border: "none",
      backgroundColor: `hsl(${r.split("").reduce((s, c) => s + c.charCodeAt(0), 0) % 360}, 70%, 80%)`,
      color: "#000",
      ...n == null ? void 0 : n.style
    }
  };
  if (n != null && n.img && (i.src = n.img), n != null && n.text)
    i.children = n.text;
  else {
    const s = r.split(" "), c = (s.length > 1 ? [s[0][0], s[s.length - 1][0]] : [s[0][0], s[0][1]]).filter(Boolean).join("").toUpperCase();
    i.children = c;
  }
  return /* @__PURE__ */ R(We, { ...i });
}, xe = {
  align: "bottom",
  size: "md",
  renderer: Hn
}, cr = ({
  messages: e,
  contentRenderer: t = Ln,
  labelRenderer: n = qn,
  roles: r,
  actionRenderer: a,
  avatar: o,
  autoScroll: i,
  ...s
}) => {
  const c = o ? {
    ...xe,
    ...typeof o == "object" ? o : {}
  } : null, m = Ie(() => {
    const u = [];
    let h = null;
    return e.forEach((y) => {
      const p = y.timestamp ? (() => {
        const g = new Date(y.timestamp);
        return Rn(g) ? "Today" : An(g) ? "Yesterday" : ue(g, "PP");
      })() : "";
      p !== h ? (u.push({
        label: p,
        messages: [y]
      }), h = p) : u[u.length - 1].messages.push(y);
    }), u;
  }, [e]);
  return Ge(() => {
    if (!i || !e.length || !m.length) return;
    const u = m.length - 1, h = m[u];
    document.querySelectorAll(
      `[data-group-index="${u}"][data-message-index="${(h == null ? void 0 : h.messages.length) - 1}"]`
    ).forEach((y) => {
      y.scrollIntoView({ behavior: "smooth" });
    });
  }, [e]), /* @__PURE__ */ R(Ve, { ...s, children: m.map((u, h) => /* @__PURE__ */ ne(Xe, { children: [
    u.label && /* @__PURE__ */ R(Qe, { children: n(u.label) }),
    u.messages.map((y, p) => {
      const { id: g, align: d, role: v, content: k } = y, f = r[v], P = d || f.align || "left";
      return /* @__PURE__ */ ne(
        Je,
        {
          "data-group-index": h,
          "data-message-index": p,
          messageAlign: P,
          children: [
            /* @__PURE__ */ R(
              Ue,
              {
                className: "avatar-wrapper",
                ...c,
                messageAlign: P,
                isEmpty: !c,
                children: c && c.renderer({
                  role: f,
                  avatarConfig: c
                })
              }
            ),
            /* @__PURE__ */ ne(
              Ke,
              {
                className: "message-content",
                align: P,
                avatarAlign: (c == null ? void 0 : c.align) || xe.align,
                backgroundColor: f.backgroundColor,
                textColor: f.color || "#000",
                children: [
                  t({ content: k, role: f, message: y }),
                  y.timestamp && /* @__PURE__ */ R(
                    "div",
                    {
                      style: { textAlign: "right" },
                      className: "text-gray-400 text-xs",
                      children: ue(y.timestamp, "hh:mm a")
                    }
                  )
                ]
              }
            ),
            a && /* @__PURE__ */ ne(He, { children: [
              /* @__PURE__ */ R("div", { className: "empty-padding" }),
              /* @__PURE__ */ R(
                Ze,
                {
                  className: "message-actions",
                  align: P,
                  children: a({ message: y, role: f })
                }
              )
            ] })
          ]
        },
        g || p
      );
    })
  ] }, h)) });
};
export {
  cr as C
};
